<script>
  import { onMount, onDestroy } from 'svelte'
  import { getCollectHealth } from '../../api.js'

  let loading = true
  let err = ''
  let data = null
  let timer

  function fmtAge(age) {
    if (age == null || Number.isNaN(Number(age))) return '—'
    const s = Math.round(Number(age))
    if (s < 90) return s + 's'
    if (s < 3600) return Math.round(s / 60) + 'm'
    return (s / 3600).toFixed(1) + 'h'
  }

  function fmtBytes(n) {
    if (n == null || Number.isNaN(Number(n))) return ''
    const b = Number(n)
    if (b < 1024) return b + ' B'
    if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KiB'
    return (b / (1024 * 1024)).toFixed(2) + ' MiB'
  }

  function pillClass(status) {
    if (status === 'OK') return 'pm-pill pm-pill--win'
    if (status === 'STALE' || status === 'WARN') return 'pm-pill pm-pill--pending'
    return 'pm-pill pm-pill--loss'
  }

  function unitActive(units, name) {
    const u = units && units[name]
    if (!u) return '—'
    if (u.active_state) return u.active_state
    if (typeof u === 'string') return u
    return u.ok === false ? 'n/a' : '—'
  }

  async function load() {
    err = ''
    try {
      const { res, data: d, unauthorized } = await getCollectHealth()
      if (unauthorized) return
      if (!res.ok || !d || !d.ok) {
        err = (d && (d.error || d.detail)) || 'collect_scan_failed'
        data = null
      } else {
        data = d
      }
    } catch {
      err = 'Сеть / API недоступны'
      data = null
    } finally {
      loading = false
    }
  }

  onMount(() => {
    load()
    timer = setInterval(load, 30_000)
  })

  onDestroy(() => {
    if (timer) clearInterval(timer)
  })
</script>

<section class="pm-surface" aria-label="Сбор рыночных данных">
  <div class="pm-section-head">
    <h2>Сбор данных</h2>
    <button type="button" class="pm-btn" on:click={() => { loading = true; load() }}>Обновить</button>
  </div>

  <p class="pm-meta">
    Живой статус пайплайна (mid / book / Bybit / Binance / Chainlink / shadow). Paper не трогаем.
  </p>

  {#if loading && !data}
    <p class="pm-meta">Загрузка…</p>
  {:else if err}
    <p class="pm-ops-msg--bad">{err}</p>
  {:else if data}
    <p class="pm-meta" style="margin-bottom:0.85rem">
      Overall
      <span class={pillClass(data.overall)}>{data.overall}</span>
      · проверено {data.generated_at_utc || '—'}
      {#if data.units}
        · timer {unitActive(data.units, 'pmbot-market-collect.timer')}
        · rtds {unitActive(data.units, 'pmbot-rtds-chainlink.service')}
        · paper {unitActive(data.units, 'pmbot-paper.service')}
      {/if}
    </p>

    <table class="pm-table">
      <thead>
        <tr>
          <th>Источник</th>
          <th>Статус</th>
          <th>Возраст</th>
          <th>Строк / размер</th>
          <th>Span</th>
          <th>Путь</th>
        </tr>
      </thead>
      <tbody>
        {#each data.sources || [] as s}
          <tr>
            <td>
              {s.label}
              {#if s.note}<div class="pm-meta">{s.note}</div>{/if}
            </td>
            <td><span class={pillClass(s.status)}>{s.status}</span></td>
            <td>{fmtAge(s.age_sec)}</td>
            <td>
              {s.rows_today != null ? s.rows_today : '—'}
              {#if s.size_bytes}<span class="pm-meta"> · {fmtBytes(s.size_bytes)}</span>{/if}
            </td>
            <td class="pm-collect-span">{s.span || s.last_ts || '—'}</td>
            <td class="pm-collect-path" title={s.path || ''}>{s.path || '—'}</td>
          </tr>
        {/each}
      </tbody>
    </table>

    <p class="pm-meta" style="margin-top:0.85rem">
      pmbot-paper must stay STOPPED (frozen stale test).
    </p>
  {/if}
</section>

<style>
  .pm-collect-span,
  .pm-collect-path {
    font-size: 0.78rem;
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .pm-collect-path {
    color: var(--pm-muted);
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  }
</style>
